/* tslint:disable */
import * as Types from '../../../../../../graphql-api/gql-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchQueryVariables = Types.Exact<{
  query: Types.SearchQuery;
}>;


export type SearchQuery = { search?: { totalResultCount: number, products?: Array<{ productId: string, displayedProductId?: string | null, articleTitle: string, title: string, color?: string | null, colorCode?: string | null, parentId?: string | null, brandId: string, mainImageUrl?: string | null, articleImageUrl: string, attributes: any, masterAttributes: any, earliestDeliveryDate?: string | null, isNew?: boolean | null, isAvailable?: boolean | null, media: Array<{ url: string, type: Types.MediaType }>, priceRanges: Array<{ markup?: number | null, currency?: string | null, validityPeriod?: { startDate?: any | null, endDate?: any | null } | null, rrp?: { max?: number | null, min?: number | null, currency?: string | null } | null, wsp?: { max?: number | null, min?: number | null, currency?: string | null } | null, wspd?: { max?: number | null, min?: number | null, currency?: string | null } | null, discount?: { max?: number | null, min?: number | null, currency?: string | null } | null }>, relatedVariants?: Array<{ attributes: any, title: string, productId: string, mainImageUrl?: string | null, media: Array<{ url: string, type: Types.MediaType }> }> | null, children?: Array<{ media: Array<{ url: string, type: Types.MediaType }> }> | null, parent?: { productId: string } | null, icons?: { hasSustainableChoiceIcon: boolean, hasPopularityIcon: boolean, hasGlobalNoosIcon: boolean, marketingSupportEolDate?: any | null, hasMarketingSupportIcon: boolean, hasNewIconByDeliveryMonth?: boolean | null } | null, labels?: Array<{ name: string, labelType: Types.ProductLabelType, data?: any | null }> | null, descriptionAttributes?: Array<{ key: string, displayName: string }> | null }> | null } | null };

export const SearchDocument = gql`
    query Search($query: SearchQuery!) {
  search(query: $query) {
    products {
      productId
      displayedProductId
      articleTitle
      title
      color
      colorCode
      parentId
      brandId
      mainImageUrl
      articleImageUrl
      media {
        url
        type
      }
      priceRanges {
        validityPeriod {
          startDate
          endDate
        }
        rrp {
          max
          min
          currency
        }
        wsp {
          max
          min
          currency
        }
        wspd {
          max
          min
          currency
        }
        markup
        discount {
          max
          min
          currency
        }
        currency
      }
      relatedVariants {
        attributes
        title
        productId
        mainImageUrl
        media {
          url
          type
        }
      }
      children {
        media {
          url
          type
        }
      }
      parent {
        productId
      }
      icons {
        hasSustainableChoiceIcon
        hasPopularityIcon
        hasGlobalNoosIcon
        marketingSupportEolDate
        hasMarketingSupportIcon
        hasNewIconByDeliveryMonth
      }
      labels {
        name
        labelType
        data
      }
      attributes
      masterAttributes
      descriptionAttributes {
        key
        displayName
      }
      earliestDeliveryDate
      isNew
      isAvailable
    }
    totalResultCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchGQL extends Apollo.Query<SearchQuery, SearchQueryVariables> {
    document = SearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }